import { newStepValue } from '../../../../services/flowBuilder/utils/constants';
import { DynamicLayout } from '../../formbuilder';

export const touch: DynamicLayout = {
  json: {
    menu: {
      menuType: 'touch',
      touch: {
        apiToken: '',
        businessHours: '',
        context: {
          departmentId: '',
        },
        noAgentMessage: '',
        successfullyConnectedMessage: '',
        leaveMessage: false,
        touchOptions: 'agent',
      },
      results: {
        success: {
          next: newStepValue,
          description: 'Touch session ended successfully',
        },
        error: {
          next: newStepValue,
          description: 'Error',
        },
      },
    },
    type: 'menu',
    metadata: {},
  },
  paths: [
    'menu.touch.apiToken',
    'menu.touch.touchOptions',
    'menu.touch.successfullyConnectedMessage',
    'menu.touch.businessHours',
    'menu.touch.context.departmentId',
    'menu.touch.noAgentMessage',
    'menu.results.#',
  ],
  groups: [
    {
      Parameters: [
        'menu.touch.apiToken',
        'menu.touch.touchOptions',
        'menu.touch.successfullyConnectedMessage',
        'menu.touch.businessHours',
        'menu.touch.context.departmentId',
        'menu.touch.noAgentMessage',
      ],
    },
    {
      Logic: ['menu.results.#'],
    },
  ],
  layout: {
    apiToken: {
      type: 'text',
      label: 'Api Token',
      validators: {
        required: true,
      },
    },
    businessHours: {
      type: 'text',
      label: 'Outside Business Hours',
      validators: {
        required: true,
      },
    },
    noAgentMessage: {
      type: 'text',
      label: 'No Agent Message',
      validators: {
        required: true,
      },
    },
    successfullyConnectedMessage: {
      type: 'text',
      label: 'Successfully Connected Message',
      validators: {
        required: true,
      },
    },
    departmentId: {
      type: 'text',
      label: 'Department ID',
    },
    touchOptions: {
      type: 'dropdown',
      label: 'Touch Options',
      validators: {
        required: true,
      },
      attributes: {
        options: {
          bot: 'Bot',
          agent: 'Agent',
          both: 'Both',
        },
      },
    },
    results: {
      dataType: 'keyObject',
      key: {
        attributes: {
          readonly: true,
        },
        type: 'text',
        label: '#',
      },
      value: {
        description: {
          type: 'text',
          label: 'Description',
        },
        next: {
          type: 'next',
          label: 'Point to',
        },
      },
    },
  },
  data: {
    results: {
      next: newStepValue,
      description: '',
    },
  },
};
